export default "__VITE_ASSET__Sm6HZNqj__"